module.exports = __webpack_public_path__ + "static/img/superior.e15dba19.png";